function onPlayerReady(event) {
  // show video
  const iframe = event.target.getIframe();
  iframe.classList.remove("hidden");

  // hide play button
  const playButton = iframe.previousElementSibling;
  playButton.classList.remove("opacity-1");
  playButton.classList.add("opacity-0");

  // play video
  event.target.playVideo();
}

function createYTPlayer(elementId, videoID) {
  return new YT.Player(elementId, {
    height: "900",
    width: "1600",
    videoId: videoID,
    playerVars: {
      "playsinline": 1,
    },
    events: {
      "onReady": onPlayerReady,
    }
  });
}

function Video(el) {
  const button = el.querySelector("[data-video-button]");
  const videoID = el.dataset.videoId;

  button.addEventListener("click", function(e) {
    e.preventDefault();

    createYTPlayer(`placeholder-${videoID}`, videoID);
    button.remove();
  });
}

export function bindVideo() {
  return [...document.querySelectorAll("[data-video]")].map((el) => Video(el));
}
